var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.$options.i18n.tooltip,"variant":"info"}},[_c('gl-icon',{attrs:{"name":"tanuki-ai"}}),_vm._v(" "),_c('span',{staticClass:"gl-sr-only",attrs:{"data-testid":"ai-resolution-badge-text"}},[_vm._v(_vm._s(_vm.$options.i18n.tooltip))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }